var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheckCircleFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.312,
    cy: 14.312,
    r: 14.312,
    fill: "#19D296",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9014 9.52598C21.5022 9.12676 20.8549 9.12676 20.4557 9.52598L11.7813 18.2003L8.16702 14.586C7.76779 14.1868 7.12052 14.1868 6.72129 14.586C6.32207 14.9852 6.32207 15.6325 6.72129 16.0317L11.7813 21.0918L21.9014 10.9717C22.3006 10.5725 22.3006 9.92521 21.9014 9.52598Z",
    fill: "#19D296"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjkiIGhlaWdodD0iMjkiIHZpZXdCb3g9IjAgMCAyOSAyOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTQuMzExOSIgY3k9IjE0LjMxMTkiIHI9IjE0LjMxMTkiIGZpbGw9IiMxOUQyOTYiIGZpbGwtb3BhY2l0eT0iMC4xIi8+CjxwYXRoIGQ9Ik0yMS45MDE0IDkuNTI1OThDMjEuNTAyMiA5LjEyNjc2IDIwLjg1NDkgOS4xMjY3NiAyMC40NTU3IDkuNTI1OThMMTEuNzgxMyAxOC4yMDAzTDguMTY3MDIgMTQuNTg2QzcuNzY3NzkgMTQuMTg2OCA3LjEyMDUyIDE0LjE4NjggNi43MjEyOSAxNC41ODZDNi4zMjIwNyAxNC45ODUyIDYuMzIyMDcgMTUuNjMyNSA2LjcyMTI5IDE2LjAzMTdMMTEuNzgxMyAyMS4wOTE4TDIxLjkwMTQgMTAuOTcxN0MyMi4zMDA2IDEwLjU3MjUgMjIuMzAwNiA5LjkyNTIxIDIxLjkwMTQgOS41MjU5OFoiIGZpbGw9IiMxOUQyOTYiLz4KPC9zdmc+Cg==";
export { SvgIconCheckCircleFilled as ReactComponent };